var _g, _g2, _g3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlaceholderMachines(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 275,
    height: 202,
    viewBox: "0 0 275 202",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M262.793 144.661V97.4918L229.597 72.364C230.894 71.3775 232.197 70.391 233.494 69.4115C234.784 68.432 235.242 66.6986 234.593 65.2188C234.396 64.7467 234.192 64.2816 233.987 63.8095C233.734 63.2176 233.917 62.5271 234.424 62.1325L252.83 48.2015C252.858 48.1804 252.879 48.1663 252.907 48.1381C252.569 47.356 252.224 46.5738 251.885 45.7916C250.335 42.212 248.785 38.6324 247.235 35.0528C246.467 33.277 244.402 32.4526 242.619 33.2277C233.043 37.3781 223.467 41.5214 213.884 45.6789C213.63 45.7916 213.39 45.9255 213.165 46.0946L202.017 54.5363L201.855 54.6561L201.813 54.6914C201.665 54.8182 201.517 54.9591 201.383 55.1141C201.151 55.2198 200.939 55.3537 200.735 55.5017L198.092 57.5029L170.456 78.431C170.421 78.4522 170.393 78.4733 170.357 78.5015L170.329 78.5297C170.252 78.586 170.174 78.6495 170.104 78.7199C169.998 78.7833 169.892 78.8538 169.794 78.9243L169.787 78.9313L158.597 87.4083L158.561 87.4294C157.3 88.3877 156.8 90.1071 157.455 91.6221C159.005 95.2087 160.563 98.7813 162.113 102.368C162.451 103.15 162.789 103.932 163.135 104.722V151.891L208.183 185.996L219.415 177.498L220.916 175.215L250.06 153.159H251.561L262.793 144.661Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M133.835 150.193C133.835 133.034 133.835 115.876 133.835 98.7179C133.835 80.6366 133.835 62.5553 133.835 44.4739C133.835 43.2972 133.56 42.1627 133.046 41.1339C132.539 40.1122 131.799 39.2032 130.862 38.4985C116.839 27.8865 102.824 17.2744 88.801 6.65537C87.6525 5.7816 86.0599 5.78865 84.9043 6.65537L42.3928 38.9143C41.364 39.4287 40.603 40.4715 40.603 41.8033C40.603 45.0447 40.603 48.2791 40.603 51.5205C31.0197 58.7713 21.4365 66.0222 11.8532 73.2801C10.6906 74.1609 10 75.542 10 77.0076C10 90.3819 10 103.763 10 117.145C10 117.863 10.3382 118.54 10.909 118.97L12.3958 120.09C12.4029 120.104 12.4169 120.111 12.431 120.118C13.1921 120.696 14.3054 120.788 15.1862 120.118C23.6632 113.706 32.126 107.294 40.603 100.881C40.603 116.433 40.603 131.977 40.603 147.529C40.603 149.876 41.6952 152.088 43.5695 153.504C57.5921 164.117 71.6076 174.729 85.6231 185.341C86.8773 186.285 88.4487 186.151 89.5268 185.341C89.5409 185.326 89.555 185.312 89.5691 185.305L132.038 153.082L133.004 152.356C133.589 151.708 133.835 151.059 133.835 150.193Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M262.793 97.4917V144.654L251.561 153.152V105.99L262.793 97.4917Z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M262.793 97.4918L251.568 105.99C251.568 105.99 251.237 105.99 250.814 105.99C250.398 105.99 250.06 105.99 250.06 105.99L220.923 128.053L219.422 130.329L208.197 138.834L163.142 104.722L177.221 98.6193L169.159 104.722L208.19 134.275L256.775 97.4918L226.588 74.64C227.589 73.879 228.597 73.118 229.597 72.364L262.793 97.4918Z",
    fill: "url(#paint1_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M256.769 97.4919L208.183 134.275L169.152 104.722L177.214 98.6193L191.285 92.5241L180.384 100.776L185.373 104.552L213.397 125.77L240.562 105.208L245.551 101.431L214.039 77.5785L217.174 75.2038C217.9 74.6542 218.95 74.929 219.309 75.7605C219.429 76.0424 219.556 76.3242 219.676 76.6061C220.218 77.8533 221.79 78.269 222.875 77.4446C223.488 76.9795 224.108 76.5074 224.728 76.0424C225.348 75.5702 225.968 75.0981 226.595 74.6331L256.769 97.4919Z",
    fill: "url(#paint2_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M251.885 45.7915C252.224 46.5737 252.562 47.3558 252.9 48.138C252.879 48.1591 252.851 48.1803 252.83 48.2014L234.424 62.1323C233.91 62.5199 233.726 63.2175 233.987 63.8094C234.192 64.2745 234.389 64.7466 234.593 65.2117C235.234 66.6985 234.783 68.4249 233.494 69.4043C232.197 70.3908 230.894 71.3703 229.597 72.3568C228.597 73.1178 227.589 73.8789 226.588 74.6328C225.968 75.105 225.348 75.5771 224.721 76.0421C223.636 76.8666 222.057 76.4508 221.522 75.2036C221.402 74.9217 221.275 74.6399 221.156 74.358C220.796 73.5265 219.746 73.2447 219.02 73.7943L217.167 75.2036L214.032 77.5783L199.347 88.6977L198.304 89.4869C197.966 88.7047 197.627 87.9155 197.282 87.1333L208.507 78.6353L209.106 78.1843L239.455 55.2056L240.653 54.2966L251.885 45.7915Z",
    fill: "url(#paint3_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M247.235 35.0456C248.785 38.6252 250.342 42.2049 251.892 45.7845L240.667 54.2826L236.01 43.5437C235.241 41.768 233.177 40.9506 231.401 41.7186C221.825 45.869 212.242 50.0194 202.666 54.1698C202.433 54.2755 202.222 54.3953 202.024 54.5292L213.172 46.0875C213.397 45.9184 213.637 45.7774 213.898 45.6647C223.474 41.5143 233.057 37.3639 242.633 33.2135C244.402 32.4525 246.467 33.2699 247.235 35.0456Z",
    fill: "url(#paint4_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.561 105.99V153.159H250.06V105.99C250.06 105.99 250.398 105.99 250.814 105.99C251.23 105.99 251.561 105.99 251.561 105.99Z",
    fill: "url(#paint5_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M250.06 105.99V153.152L220.916 175.215V128.053L250.06 105.99Z",
    fill: "url(#paint6_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M245.543 101.431L240.554 105.208V101.431L212.531 80.214L185.366 100.776V104.553L180.384 100.776L191.285 92.5242L198.304 89.4802L199.347 88.6909L214.031 77.5786L245.543 101.431Z",
    fill: "url(#paint7_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.003 43.5439L240.66 54.2828L239.462 55.1918L234.805 44.4529C234.037 42.6772 231.972 41.8598 230.189 42.6279C220.613 46.7783 211.037 50.9287 201.453 55.0791C201.425 55.0861 201.397 55.1002 201.376 55.1143C201.51 54.9522 201.651 54.8183 201.806 54.6915L201.848 54.6563L202.01 54.5365C202.207 54.3955 202.419 54.2758 202.651 54.1771C212.228 50.0267 221.811 45.8763 231.387 41.7259C233.17 40.9508 235.234 41.7682 236.003 43.5439Z",
    fill: "url(#paint8_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M240.555 101.431V105.208L213.397 125.769V121.992L240.555 101.431Z",
    fill: "url(#paint9_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.555 101.431L213.397 121.993L185.366 100.776L212.531 80.2139L240.555 101.431Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M234.805 44.4528L239.462 55.1917H238.497L233.994 44.7981C233.417 43.4734 231.88 42.8603 230.549 43.4381L198.092 57.4959L200.735 55.4947C200.939 55.3397 201.151 55.2128 201.383 55.1071C201.404 55.1001 201.432 55.086 201.461 55.0719C211.037 50.9215 220.613 46.7711 230.196 42.6207C231.972 41.8597 234.037 42.6771 234.805 44.4528Z",
    fill: "url(#paint10_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M239.462 55.1987L209.113 78.1703L208.874 77.6207L238.497 55.1987H239.462Z",
    fill: "url(#paint11_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M233.994 44.8052L238.497 55.1988L208.873 77.6278L204.455 67.4386C203.687 65.6629 201.622 64.8455 199.84 65.6135C190.264 69.7639 180.687 73.9143 171.104 78.0647C170.829 78.1774 170.583 78.3254 170.35 78.5086L198.085 57.5101L230.541 43.4523C231.873 42.8674 233.416 43.4805 233.994 44.8052Z",
    fill: "url(#paint12_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M224.721 76.0493C224.101 76.5144 223.488 76.9865 222.868 77.4516C221.776 78.276 220.204 77.8603 219.669 76.613C219.549 76.3312 219.422 76.0493 219.302 75.7674C218.943 74.936 217.893 74.6541 217.167 75.2108L219.02 73.8085C219.746 73.2589 220.796 73.5337 221.155 74.3722C221.275 74.6541 221.402 74.936 221.522 75.2178C222.057 76.458 223.636 76.8737 224.721 76.0493Z",
    fill: "url(#paint13_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.916 128.052V175.215L219.415 177.491V130.329L220.916 128.052Z",
    fill: "url(#paint14_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M219.415 130.329V177.491L208.183 185.989V138.827L219.415 130.329Z",
    fill: "url(#paint15_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M213.397 121.992V125.769L185.366 104.552V100.775L213.397 121.992Z",
    fill: "url(#paint16_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.873 77.6206L209.113 78.1702L208.514 78.6212L203.856 67.8823C203.088 66.1066 201.024 65.2892 199.241 66.0573C189.665 70.2076 180.081 74.351 170.505 78.5084C170.364 78.5718 170.23 78.6423 170.097 78.7198C170.167 78.6493 170.245 78.5859 170.322 78.5225L170.357 78.4943C170.583 78.3182 170.836 78.1702 171.111 78.0504C180.687 73.9 190.264 69.7496 199.847 65.5992C201.623 64.8312 203.687 65.6486 204.462 67.4243L208.873 77.6206Z",
    fill: "url(#paint17_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M203.856 67.8823L208.514 78.6211L197.289 87.1192C195.739 83.5396 194.181 79.96 192.631 76.3804C191.863 74.6046 189.798 73.7873 188.023 74.5553C178.446 78.7057 168.863 82.8561 159.287 87.0065C159.04 87.1122 158.808 87.2461 158.604 87.4011L169.793 78.9312L169.8 78.9241C169.899 78.8537 169.998 78.7832 170.103 78.7198C170.237 78.6423 170.371 78.5718 170.512 78.5084C180.088 74.358 189.665 70.2076 199.248 66.0572C201.023 65.2892 203.088 66.1066 203.856 67.8823Z",
    fill: "url(#paint18_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M208.183 138.826V185.989L163.135 151.884V104.721L208.183 138.826Z",
    fill: "url(#paint19_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M197.282 87.1262C197.62 87.9084 197.958 88.6976 198.304 89.4798L191.285 92.5238L177.214 98.6191L163.135 104.721C162.796 103.939 162.458 103.15 162.113 102.368L197.282 87.1262Z",
    fill: "url(#paint20_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M192.624 76.3805C194.175 79.9601 195.732 83.5468 197.282 87.1194L162.113 102.354C160.563 98.7743 159.005 95.1947 157.455 91.615C156.8 90.1001 157.293 88.3807 158.561 87.4224L158.597 87.3942C158.808 87.2392 159.034 87.1053 159.28 86.9996C168.856 82.8492 178.44 78.6988 188.016 74.5484C189.792 73.7944 191.856 74.6048 192.624 76.3805Z",
    fill: "url(#paint21_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M133.835 98.7108C133.835 115.869 133.835 133.027 133.835 150.185C133.835 151.059 133.589 151.7 133.004 152.349L132.045 153.082L89.5762 185.298C90.309 184.727 90.8093 183.833 90.8093 182.761C90.8093 165.603 90.8093 148.445 90.8093 131.287C90.8093 113.205 90.8093 95.1241 90.8093 77.0428C90.8093 75.866 90.5345 74.7315 90.0271 73.7098L129.776 43.6212L133.06 41.1409C133.567 42.1626 133.842 43.3041 133.842 44.4739C133.835 62.5481 133.835 80.6365 133.835 98.7108Z",
    fill: "url(#paint22_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M129.769 43.6142L90.0201 73.7028C89.5128 72.6811 88.7659 71.7721 87.8357 71.0604C73.8132 60.4483 59.7906 49.8363 45.7751 39.2243C44.7111 38.421 43.4216 38.3928 42.3928 38.9072L84.9044 6.65532C86.06 5.78156 87.6525 5.78156 88.8011 6.65532C102.824 17.2674 116.839 27.8794 130.862 38.4914C131.799 39.1961 132.539 40.1051 133.046 41.1339L129.769 43.6142Z",
    fill: "url(#paint23_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M90.8022 131.287C90.8022 148.445 90.8022 165.603 90.8022 182.761C90.8022 183.84 90.3019 184.727 89.5691 185.298C89.555 185.312 89.5409 185.326 89.5197 185.333C88.4416 186.144 86.8703 186.278 85.616 185.333C71.6005 174.721 57.5779 164.109 43.5625 153.497C41.6881 152.081 40.5888 149.868 40.5888 147.522C40.5888 131.97 40.5888 116.426 40.5888 100.874C42.3152 99.5634 44.0487 98.2528 45.7751 96.9492C46.9377 96.0683 47.6212 94.7013 47.6283 93.2427C47.6353 94.7013 48.3188 96.0683 49.4815 96.9492C59.6778 104.672 69.8811 112.388 80.0774 120.111C81.5854 121.253 83.7416 120.174 83.7416 118.286C83.7416 104.905 83.7416 91.5304 83.7416 78.1491C83.7416 76.6834 83.0581 75.3023 81.8884 74.4215C71.8119 66.7901 61.7283 59.1588 51.6518 51.5344C50.003 50.2802 47.6353 51.4569 47.6212 53.5216C47.6142 52.6478 47.1844 51.9291 46.5643 51.4922C46.5643 51.4851 46.5572 51.4851 46.5502 51.4781L45.1056 50.3859C44.2037 49.7024 42.9635 49.7024 42.0686 50.3859C41.5683 50.7664 41.075 51.1398 40.5818 51.5133C40.5818 48.2719 40.5818 45.0376 40.5818 41.7962C40.5818 40.4644 41.3428 39.4215 42.3716 38.9071C43.4004 38.3998 44.6969 38.4209 45.7539 39.2242C59.7694 49.8362 73.792 60.4483 87.8145 71.0603C88.7517 71.765 89.4916 72.674 89.9989 73.7027C90.5063 74.7245 90.7811 75.866 90.7811 77.0357C90.8022 95.1241 90.8022 113.205 90.8022 131.287ZM83.7628 172.502C83.7628 159.12 83.7628 145.746 83.7628 132.365C83.7628 130.899 83.0792 129.518 81.9095 128.637C71.833 121.006 61.7495 113.382 51.673 105.75C50.0171 104.496 47.6424 105.673 47.6424 107.751C47.6424 120.978 47.6424 134.204 47.6424 147.43C47.6424 148.896 48.3259 150.277 49.4956 151.165C59.6919 158.888 69.8952 166.604 80.0915 174.327C81.5995 175.461 83.7628 174.39 83.7628 172.502Z",
    fill: "url(#paint24_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M83.7628 132.358C83.7628 145.739 83.7628 159.113 83.7628 172.494C83.7628 174.383 81.5996 175.461 80.0986 174.32C69.8953 166.604 59.692 158.881 49.4957 151.158C48.333 150.277 47.6425 148.889 47.6425 147.423C47.6425 134.197 47.6425 120.97 47.6425 107.744C47.6425 105.665 50.0171 104.489 51.6731 105.743C61.7496 113.374 71.8261 120.999 81.9096 128.63C83.0723 129.518 83.7628 130.892 83.7628 132.358ZM82.9948 172.502C82.9948 159.12 82.9948 145.746 82.9948 132.365C82.9948 131.139 82.4169 129.99 81.4445 129.25C78.4498 126.981 75.448 124.712 72.4532 122.443C68.7467 119.639 65.0473 116.841 61.3479 114.037C61.1365 113.875 60.9181 113.713 60.7137 113.558C57.5428 111.162 54.3789 108.759 51.215 106.363C50.0665 105.496 48.4105 106.314 48.4105 107.751C48.4105 120.978 48.4105 134.204 48.4105 147.43C48.4105 148.656 48.9883 149.805 49.9608 150.545C60.157 158.268 70.3533 165.991 80.5567 173.706C81.5573 174.468 82.9948 173.756 82.9948 172.502Z",
    fill: "url(#paint25_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M53.9984 99.3944C62.8488 106.103 71.7063 112.797 80.5567 119.505C81.4516 120.182 82.6847 119.688 82.9454 118.681C82.9807 118.561 82.9948 118.427 82.9948 118.293C82.9948 117.8 82.9948 117.307 82.9948 116.813C82.9948 115.503 82.9948 114.192 82.9948 112.881C82.9948 101.304 82.9948 89.7337 82.9948 78.1492C82.9948 76.9231 82.4169 75.7746 81.4445 75.0347C81.3177 74.936 81.1909 74.8374 81.064 74.7458C80.1198 74.027 79.1685 73.3153 78.2243 72.5966C69.2188 65.7826 60.2134 58.9686 51.215 52.1476C50.0665 51.2739 48.4105 52.0983 48.4105 53.5358C48.4105 54.6985 48.4105 55.8611 48.4105 57.0309C48.4105 57.7355 48.4105 58.4331 48.4105 59.1307V59.1378C48.2062 59.2857 47.9455 59.3773 47.6495 59.3773C47.6495 57.4325 47.6495 55.4806 47.6495 53.5287C47.6495 53.5217 47.6495 53.5147 47.6495 53.5076C47.6636 51.443 50.0312 50.2733 51.6801 51.5205C61.7566 59.1448 71.8331 66.7762 81.9166 74.4075C83.0793 75.2884 83.7699 76.6695 83.7699 78.1351C83.7699 91.5164 83.7699 104.891 83.7699 118.272C83.7699 120.16 81.6066 121.239 80.1057 120.097C69.8953 112.395 59.692 104.672 49.4957 96.9563C48.333 96.0755 47.6495 94.7085 47.6425 93.2499C47.6425 93.2428 47.6425 93.2358 47.6425 93.2217C47.6425 92.1365 47.6425 91.0584 47.6425 89.9803C47.9314 89.9803 48.1921 89.8887 48.4105 89.7266C48.4105 90.8893 48.4105 92.052 48.4105 93.2217C48.4105 94.4478 48.9883 95.5964 49.9608 96.3362C51.3066 97.358 52.6525 98.3797 53.9984 99.3944Z",
    fill: "url(#paint26_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.9946 132.358C82.9946 145.739 82.9946 159.113 82.9946 172.495C82.9946 173.749 81.5571 174.461 80.5565 173.707C70.3603 165.984 60.1569 158.268 49.9606 150.545C48.9812 149.805 48.4104 148.649 48.4104 147.43C48.4104 134.204 48.4104 120.978 48.4104 107.751C48.4104 106.314 50.0593 105.49 51.2149 106.363C54.3788 108.759 57.5497 111.162 60.7136 113.558L60.0794 114.037C56.9719 111.683 53.8573 109.33 50.7498 106.969C50.1086 106.483 49.1855 106.941 49.1855 107.751C49.1855 120.978 49.1855 134.204 49.1855 147.43C49.1855 148.417 49.6435 149.34 50.4327 149.932C55.4428 153.723 60.4529 157.521 65.4629 161.312L66.1464 160.748V161.833C71.1072 165.589 76.0679 169.345 81.0216 173.094C81.5149 173.467 82.2266 173.115 82.2266 172.495C82.2266 159.113 82.2266 145.739 82.2266 132.358C82.2266 131.371 81.7685 130.448 80.9793 129.856C77.9282 127.545 74.87 125.234 71.8189 122.923L72.4531 122.443C75.4478 124.712 78.4496 126.981 81.4444 129.25C82.4168 129.983 82.9946 131.139 82.9946 132.358Z",
    fill: "url(#paint27_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M82.9947 116.813C82.9947 117.307 82.9947 117.8 82.9947 118.293C82.9947 118.427 82.9806 118.561 82.9454 118.681L53.9984 96.766L51.4053 94.8071V92.8975L82.9947 116.813Z",
    fill: "url(#paint28_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M82.9947 112.882C82.9947 114.192 82.9947 115.503 82.9947 116.813L51.4053 92.8976L78.2243 72.5967C79.1685 73.3154 80.1198 74.0271 81.064 74.7459L56.8452 93.0809L81.064 111.416L82.9947 112.882Z",
    fill: "url(#paint29_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.9947 78.1564C82.9947 89.7338 82.9947 101.304 82.9947 112.889L81.0639 111.423L56.8451 93.0879L81.0639 74.7529C81.1908 74.8516 81.3176 74.9502 81.4444 75.0418C82.4169 75.7747 82.9947 76.9303 82.9947 78.1564Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M53.9984 96.7659L82.9454 118.681C82.6918 119.688 81.4516 120.174 80.5567 119.505C71.6992 112.804 62.8488 106.102 53.9984 99.3942V96.7659Z",
    fill: "url(#paint30_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M82.2267 132.358C82.2267 145.739 82.2267 159.113 82.2267 172.495C82.2267 173.115 81.5221 173.467 81.0218 173.094C76.061 169.338 71.1003 165.589 66.1466 161.833V160.748V122.648L70.5366 125.967L70.5577 125.981C71.0651 126.368 71.8261 126.016 71.8261 125.347V125.008V122.915C74.8772 125.227 77.9354 127.538 80.9865 129.849C81.7617 130.448 82.2267 131.378 82.2267 132.358Z",
    fill: "url(#paint31_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M78.2241 72.5964L51.4052 92.8974V94.807L53.9983 96.7659V99.3943C52.6524 98.3796 51.3065 97.3579 49.9606 96.3432C48.9812 95.6033 48.4104 94.4477 48.4104 93.2286C48.4104 92.0659 48.4104 90.9033 48.4104 89.7335C48.7345 89.501 48.9459 89.1134 48.9459 88.6836V85.4563C48.9671 85.0547 48.798 84.6389 48.4104 84.3571V76.0704C48.7345 75.8378 48.9459 75.4503 48.9459 75.0204V71.7931C48.9671 71.3915 48.798 70.9828 48.4104 70.6939V62.4142C48.7345 62.1817 48.9459 61.7942 48.9459 61.3643V58.137C48.9671 57.7354 48.798 57.3267 48.4104 57.0378C48.4104 55.8751 48.4104 54.7054 48.4104 53.5427C48.4104 52.1052 50.0593 51.2808 51.2149 52.1545C60.2133 58.9685 69.2187 65.7825 78.2241 72.5964Z",
    fill: "url(#paint32_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.3478 114.03C65.0472 116.834 68.7466 119.632 72.4531 122.436L71.8189 122.915V125.008L67.3725 121.64L66.689 122.204V121.119L62.2427 117.75C61.686 117.328 61.3619 116.672 61.3619 115.975V114.03H61.3478Z",
    fill: "url(#paint33_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M70.5294 125.974L66.1394 122.655L66.6749 122.218L67.3585 121.654L71.8048 125.023V125.361C71.8048 126.023 71.0438 126.375 70.5364 125.995L70.5294 125.974Z",
    fill: "url(#paint34_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M66.6822 121.126V122.211L66.1466 122.655V160.748L65.4561 161.312V122.133L66.6822 121.126Z",
    fill: "url(#paint35_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.682 121.126L65.4559 122.126L60.9603 118.723C60.4036 118.3 60.0795 117.645 60.0795 116.947V114.03L60.7137 113.551C60.925 113.706 61.1364 113.868 61.3478 114.03V115.982C61.3478 116.679 61.679 117.335 62.2287 117.758L66.682 121.126Z",
    fill: "url(#paint36_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M65.456 122.133V161.319C60.4459 157.528 55.4359 153.73 50.4258 149.939C49.6437 149.347 49.1786 148.417 49.1786 147.437C49.1786 134.211 49.1786 120.985 49.1786 107.758C49.1786 106.948 50.1017 106.497 50.7429 106.976C53.8504 109.33 56.965 111.683 60.0725 114.044V116.961C60.0725 117.659 60.3966 118.314 60.9533 118.737L65.456 122.133Z",
    fill: "url(#paint37_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M48.9459 58.1371C48.9318 58.5317 48.7345 58.9122 48.4104 59.1447V59.1377C48.4104 58.4331 48.4104 57.7354 48.4104 57.0378C48.798 57.3197 48.96 57.7354 48.9459 58.1371Z",
    fill: "url(#paint38_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M48.9459 71.7934C48.9318 72.188 48.7345 72.5685 48.4104 72.801V72.794V70.6941C48.798 70.983 48.96 71.3987 48.9459 71.7934Z",
    fill: "url(#paint39_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M48.9459 85.4564C48.9318 85.851 48.7345 86.2315 48.4104 86.464V86.45V84.3501C48.798 84.639 48.96 85.0547 48.9459 85.4564Z",
    fill: "url(#paint40_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M48.9461 85.4563V88.6836C48.9461 89.1134 48.7347 89.501 48.4106 89.7335C48.1921 89.8886 47.9314 89.9872 47.6425 89.9872C47.3536 89.9872 47.0858 89.8956 46.8744 89.7335C46.5503 89.494 46.3459 89.1134 46.3459 88.6836V85.4563C46.36 85.8509 46.5573 86.2314 46.8815 86.471C47.0858 86.619 47.3465 86.7106 47.6425 86.7106C47.9455 86.7106 48.1992 86.619 48.4035 86.471C48.7347 86.2314 48.932 85.8439 48.9461 85.4563Z",
    fill: "url(#paint41_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M48.9461 71.7932V75.0205C48.9461 75.4503 48.7347 75.8379 48.4106 76.0704C48.1921 76.2255 47.9314 76.3241 47.6425 76.3241C47.3536 76.3241 47.0858 76.2325 46.8744 76.0704C46.5503 75.8309 46.3459 75.4503 46.3459 75.0205V71.7932C46.36 72.1878 46.5573 72.5683 46.8815 72.8009C47.0858 72.9488 47.3465 73.0404 47.6425 73.0404C47.9455 73.0404 48.1992 72.9488 48.4035 72.8009C48.7347 72.5683 48.932 72.1878 48.9461 71.7932Z",
    fill: "url(#paint42_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M48.9461 58.1372V61.3645C48.9461 61.7943 48.7347 62.1748 48.4106 62.4144C48.1921 62.5695 47.9314 62.6681 47.6425 62.6681C47.3536 62.6681 47.0858 62.5765 46.8744 62.4144C46.5503 62.1819 46.3459 61.7943 46.3459 61.3645V58.1372C46.36 58.5318 46.5573 58.9123 46.8815 59.1449C47.0858 59.2928 47.3465 59.3844 47.6425 59.3844C47.9455 59.3844 48.1992 59.2928 48.4035 59.1449C48.7347 58.9123 48.932 58.5248 48.9461 58.1372Z",
    fill: "url(#paint43_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M48.4104 84.3499V86.4498V86.4639C48.2061 86.6119 47.9454 86.7035 47.6494 86.7035V76.3169C47.9383 76.3169 48.199 76.2253 48.4175 76.0632V84.3499H48.4104Z",
    fill: "url(#paint44_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M48.4104 70.6939V72.7938V72.8008C48.2061 72.9488 47.9454 73.0404 47.6494 73.0404V62.6609C47.9383 62.6609 48.199 62.5693 48.4175 62.4072V70.6939H48.4104Z",
    fill: "url(#paint45_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M46.5853 51.4922C47.2054 51.9291 47.6353 52.6479 47.6423 53.5216C47.6423 53.5287 47.6423 53.5357 47.6423 53.5428C47.6423 55.4946 47.6423 57.4395 47.6423 59.3914C47.3393 59.3914 47.0856 59.2997 46.8813 59.1518L46.8742 59.1447C46.8742 58.4401 46.8742 57.7425 46.8742 57.0449C46.8742 55.8822 46.8742 54.7125 46.8742 53.5498C46.8742 52.1123 45.2254 51.2879 44.0697 52.1616C33.9932 59.793 23.9167 67.4173 13.8402 75.0487C12.8608 75.7886 12.29 76.9442 12.29 78.1632C12.29 83.5609 12.29 88.9585 12.29 94.3561C12.9101 93.891 13.5302 93.4189 14.1432 92.9538C14.3405 92.8059 14.6224 92.9468 14.6224 93.1934C14.6224 93.5105 14.6224 93.8276 14.6224 94.1517C14.6224 95.8922 14.6224 97.6327 14.6224 99.3732C14.6224 99.5776 14.6224 99.7749 14.6224 99.9722C14.6224 100.205 14.5449 100.36 14.3617 100.501C13.6711 101.022 12.9806 101.544 12.29 102.065C12.29 107.477 12.29 112.888 12.29 118.3C12.29 119.554 13.7275 120.266 14.7211 119.512C24.9173 111.789 35.1207 104.073 45.317 96.3503C46.2964 95.6104 46.8672 94.4548 46.8672 93.2357C46.8672 92.073 46.8672 90.9104 46.8672 89.7406C47.0856 89.8957 47.3464 89.9943 47.6353 89.9943C47.6353 91.0795 47.6353 92.1576 47.6353 93.2357C47.6353 93.2428 47.6353 93.2498 47.6353 93.2639C47.6282 94.7225 46.9447 96.0895 45.782 96.9704C44.0556 98.281 42.3222 99.5916 40.5958 100.895C32.1259 107.308 23.656 113.72 15.1861 120.132C14.3053 120.802 13.192 120.71 12.4239 120.132C12.4098 120.125 12.3957 120.111 12.3887 120.104C11.8672 119.702 11.5149 119.068 11.5149 118.307C11.5149 104.926 11.5149 91.5516 11.5149 78.1703C11.5149 76.7046 12.1984 75.3235 13.3681 74.4427C23.4446 66.8113 33.5211 59.18 43.5976 51.5556C44.5418 50.8369 45.7257 50.9144 46.5642 51.4993C46.5783 51.4852 46.5853 51.4852 46.5853 51.4922Z",
    fill: "url(#paint46_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M47.6425 62.6609V73.0404C47.3395 73.0404 47.0858 72.9488 46.8814 72.8009L46.8744 72.7938V70.6939V62.4143C47.0928 62.5693 47.3535 62.6609 47.6425 62.6609Z",
    fill: "url(#paint47_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M46.339 58.1371C46.3178 57.7354 46.4799 57.3267 46.8675 57.0378C46.8675 57.7425 46.8675 58.4401 46.8675 59.1377L46.8745 59.1447C46.5504 58.9122 46.3601 58.5247 46.339 58.1371Z",
    fill: "url(#paint48_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M46.339 71.7934C46.3178 71.3917 46.4799 70.983 46.8675 70.6941V72.794L46.8745 72.801C46.5504 72.5685 46.3601 72.188 46.339 71.7934Z",
    fill: "url(#paint49_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M46.339 85.4493C46.3178 85.0477 46.4799 84.639 46.8675 84.3501V86.45L46.8745 86.464C46.5504 86.2245 46.3601 85.844 46.339 85.4493Z",
    fill: "url(#paint50_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M38.5665 65.254C38.5031 65.2821 38.4467 65.3174 38.3903 65.3597C32.2669 69.9963 26.1435 74.6258 20.0201 79.2624C19.4282 79.7134 19.0829 80.411 19.0829 81.1579C19.0829 89.1346 19.0829 97.1182 19.0829 105.095C19.0829 105.243 19.0829 105.391 19.0829 105.539C19.0829 106.3 19.9567 106.737 20.5627 106.272C26.7565 101.579 32.9575 96.8928 39.1513 92.1998C39.7432 91.7488 40.0956 91.0512 40.0956 90.3043C40.0956 89.5996 40.0956 88.8879 40.0956 88.1833C40.0956 81.9894 40.0956 75.7885 40.0956 69.5946C40.0956 68.4601 40.0956 67.3327 40.0956 66.1982C40.0885 65.4019 39.2429 64.9157 38.5665 65.254ZM46.8743 89.7265C46.8743 90.8891 46.8743 92.0518 46.8743 93.2215C46.8743 94.4476 46.3035 95.5962 45.3241 96.3361C35.1278 104.059 24.9244 111.782 14.7282 119.498C13.7276 120.252 12.2971 119.547 12.2971 118.286C12.2971 112.874 12.2971 107.463 12.2971 102.051C12.9877 101.529 13.6782 101.008 14.3688 100.486C14.559 100.338 14.6295 100.191 14.6295 99.958C14.6295 99.7536 14.6295 99.5563 14.6295 99.359C14.6295 97.6185 14.6295 95.8781 14.6295 94.1376C14.6295 93.8205 14.6295 93.5034 14.6295 93.1792C14.6295 92.9326 14.3477 92.7917 14.1503 92.9397C13.5303 93.4047 12.9102 93.8769 12.2971 94.3419C12.2971 88.9443 12.2971 83.5467 12.2971 78.1491C12.2971 76.923 12.8679 75.7744 13.8473 75.0345C23.9238 67.4031 34.0003 59.7788 44.0768 52.1475C45.2254 51.2737 46.8814 52.0981 46.8814 53.5356C46.8814 54.6983 46.8814 55.861 46.8814 57.0307C46.4938 57.3196 46.3317 57.7283 46.3529 58.1299V61.3572C46.3529 61.7871 46.5643 62.1676 46.8814 62.4072V70.6868C46.4938 70.9757 46.3317 71.3844 46.3529 71.7861V75.0134C46.3529 75.4432 46.5643 75.8237 46.8814 76.0633V84.3429C46.4938 84.6248 46.3317 85.0405 46.3529 85.4422V88.6695C46.3388 89.1134 46.5502 89.4939 46.8743 89.7265Z",
    fill: "url(#paint51_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1268 50.3861L46.5713 51.4783C45.7328 50.8935 44.549 50.8159 43.6048 51.5347C33.5283 59.159 23.4518 66.7904 13.3753 74.4217C12.2056 75.3025 11.522 76.6837 11.522 78.1493C11.522 91.5306 11.522 104.905 11.522 118.286C11.522 119.047 11.8744 119.674 12.3958 120.083L10.909 118.956C10.3382 118.533 10 117.856 10 117.145C10 103.763 10 90.3821 10 77.0078C10 75.5421 10.6835 74.161 11.8532 73.2802C21.4365 66.0293 31.0127 58.7714 40.5959 51.5206C41.0962 51.1401 41.5895 50.7666 42.0827 50.3932C42.9847 49.7096 44.2249 49.7096 45.1268 50.3861Z",
    fill: "url(#paint52_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0885 88.1904C40.0885 88.8951 40.0885 89.6068 40.0885 90.3114C40.0885 91.0583 39.7362 91.7559 39.1442 92.2069C32.9504 96.8999 26.7494 101.586 20.5556 106.279C19.9496 106.737 19.0758 106.307 19.0758 105.546C19.0758 105.398 19.0758 105.25 19.0758 105.102C25.2556 100.423 31.4424 95.7372 37.6222 91.0583C38.2141 90.6074 38.5594 89.9098 38.5594 89.1628C38.5594 88.4582 38.5594 87.7465 38.5594 87.0418V68.4532V65.254C39.2429 64.9229 40.0814 65.402 40.0814 66.2053C40.0814 67.3398 40.0814 68.4743 40.0814 69.6017C40.0885 75.7956 40.0885 81.9965 40.0885 88.1904Z",
    fill: "url(#paint53_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M38.5665 87.0346C38.5665 87.7393 38.5665 88.451 38.5665 89.1556C38.5665 89.8955 38.2141 90.6002 37.6293 91.0512C31.4425 95.73 25.2627 100.416 19.0829 105.095C19.0829 97.1182 19.0829 89.1345 19.0829 81.1579C19.0829 80.418 19.4352 79.7133 20.0201 79.2624C26.1435 74.6258 32.2669 69.9962 38.3903 65.3596C38.4467 65.3173 38.5101 65.2821 38.5665 65.2539V68.453V87.0346Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M240.555 101.431L213.397 121.993L185.366 100.776L212.531 80.2139L240.555 101.431Z",
    fill: "url(#paint54_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M82.9947 78.1564C82.9947 89.7338 82.9947 101.304 82.9947 112.889L81.0639 111.423L56.8451 93.0879L81.0639 74.7529C81.1908 74.8516 81.3176 74.9502 81.4444 75.0418C82.4169 75.7747 82.9947 76.9303 82.9947 78.1564Z",
    fill: "url(#paint55_linear)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 149.167,
    y: 28.936,
    width: 125.627,
    height: 173.06,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.2 0 0 0 0 0.576471 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d",
    x: 2,
    y: 2.00269,
    width: 143.835,
    height: 199.997,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.2 0 0 0 0 0.576471 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d",
    x: 0,
    y: 0,
    width: 272.793,
    height: 199.992,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 251.563,
    y1: 125.322,
    x2: 262.792,
    y2: 125.322,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A2ABC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8691AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 163.133,
    y1: 105.593,
    x2: 262.792,
    y2: 105.593,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5ADC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7B87A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#697797"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 169.153,
    y1: 104.453,
    x2: 256.772,
    y2: 104.453,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A2ABC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8691AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 197.282,
    y1: 67.6347,
    x2: 252.905,
    y2: 67.6347,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A2ABC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8691AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 202.017,
    y1: 43.7328,
    x2: 251.888,
    y2: 43.7328,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5ADC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7B87A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#697797"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 163.132,
    y1: 129.571,
    x2: 262.792,
    y2: 129.571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5ADC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7B87A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#697797"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 220.919,
    y1: 140.601,
    x2: 250.059,
    y2: 140.601,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A2ABC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8691AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 180.381,
    y1: 91.3909,
    x2: 245.543,
    y2: 91.3909,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5ADC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7B87A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#697797"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: 201.384,
    y1: 48.3142,
    x2: 240.659,
    y2: 48.3142,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5ADC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7B87A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#697797"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear",
    x1: 213.395,
    y1: 113.599,
    x2: 240.557,
    y2: 113.599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A2ABC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8691AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear",
    x1: 198.094,
    y1: 49.9218,
    x2: 239.46,
    y2: 49.9218,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5ADC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7B87A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#697797"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear",
    x1: 208.872,
    y1: 66.684,
    x2: 239.46,
    y2: 66.684,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A2ABC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8691AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear",
    x1: 170.359,
    y1: 60.8619,
    x2: 238.496,
    y2: 60.8619,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A2ABC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8691AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear",
    x1: 217.165,
    y1: 75.6976,
    x2: 224.719,
    y2: 75.6976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5ADC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7B87A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#697797"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear",
    x1: 219.415,
    y1: 152.772,
    x2: 220.919,
    y2: 152.772,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5ADC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7B87A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#697797"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear",
    x1: 208.186,
    y1: 158.159,
    x2: 219.415,
    y2: 158.159,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A2ABC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8691AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear",
    x1: 185.368,
    y1: 113.271,
    x2: 213.395,
    y2: 113.271,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5ADC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7B87A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#697797"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear",
    x1: 170.101,
    y1: 72.0178,
    x2: 209.111,
    y2: 72.0178,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5ADC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7B87A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#697797"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear",
    x1: 158.597,
    y1: 76.5875,
    x2: 208.511,
    y2: 76.5875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A2ABC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8691AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear",
    x1: 163.133,
    y1: 145.355,
    x2: 208.186,
    y2: 145.355,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A2ABC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8691AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear",
    x1: 162.112,
    y1: 95.9215,
    x2: 198.303,
    y2: 95.9215,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A2ABC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8691AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear",
    x1: 157.168,
    y1: 88.3171,
    x2: 197.282,
    y2: 88.3171,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A2ABC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8691AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear",
    x1: 89.5726,
    y1: 113.217,
    x2: 133.833,
    y2: 113.217,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A2ABC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8691AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear",
    x1: 42.3903,
    y1: 39.8541,
    x2: 133.048,
    y2: 39.8541,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A2ABC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8691AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear",
    x1: 40.6001,
    y1: 112.283,
    x2: 90.803,
    y2: 112.283,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A2ABC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8691AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear",
    x1: 47.6431,
    y1: 140.01,
    x2: 83.7602,
    y2: 140.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5ADC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7B87A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#697797"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear",
    x1: 47.6431,
    y1: 85.8036,
    x2: 83.7602,
    y2: 85.8036,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4ACC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6854,
    stopColor: "#627091"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F5F82"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear",
    x1: 48.4097,
    y1: 140.01,
    x2: 82.9933,
    y2: 140.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4ACC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6854,
    stopColor: "#627091"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F5F82"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear",
    x1: 51.4056,
    y1: 105.789,
    x2: 82.9934,
    y2: 105.789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A2ABC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8691AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear",
    x1: 51.4056,
    y1: 94.7053,
    x2: 82.9934,
    y2: 94.7053,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5ADC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7B87A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#697797"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear",
    x1: 53.9965,
    y1: 108.289,
    x2: 82.944,
    y2: 108.289,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5ADC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7B87A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#697797"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear",
    x1: 66.1438,
    y1: 147.951,
    x2: 82.2236,
    y2: 147.951,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A2ABC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8691AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear",
    x1: 48.4097,
    y1: 75.5928,
    x2: 78.2228,
    y2: 75.5928,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A2ABC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8691AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear",
    x1: 61.3484,
    y1: 119.525,
    x2: 72.4538,
    y2: 119.525,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4ACC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6854,
    stopColor: "#627091"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F5F82"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear",
    x1: 66.1436,
    y1: 123.9,
    x2: 71.8168,
    y2: 123.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5ADC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7B87A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#697797"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear",
    x1: 65.4574,
    y1: 141.221,
    x2: 66.6817,
    y2: 141.221,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5ADC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7B87A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#697797"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear",
    x1: 60.0778,
    y1: 117.84,
    x2: 66.6816,
    y2: 117.84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4ACC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6854,
    stopColor: "#627091"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F5F82"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear",
    x1: 49.1796,
    y1: 134.042,
    x2: 65.4573,
    y2: 134.042,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A2ABC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8691AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear",
    x1: 48.4066,
    y1: 58.0902,
    x2: 48.9459,
    y2: 58.0902,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5ADC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7B87A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#697797"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear",
    x1: 48.4066,
    y1: 71.7495,
    x2: 48.9459,
    y2: 71.7495,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5ADC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7B87A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#697797"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear",
    x1: 48.4066,
    y1: 85.4085,
    x2: 48.9459,
    y2: 85.4085,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5ADC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7B87A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#697797"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear",
    x1: 46.3415,
    y1: 87.7148,
    x2: 48.9447,
    y2: 87.7148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5ADC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7B87A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#697797"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear",
    x1: 46.3415,
    y1: 74.0573,
    x2: 48.9447,
    y2: 74.0573,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5ADC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7B87A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#697797"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear",
    x1: 46.3415,
    y1: 60.3998,
    x2: 48.9447,
    y2: 60.3998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5ADC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7B87A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#697797"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear",
    x1: 47.643,
    y1: 81.3875,
    x2: 48.4097,
    y2: 81.3875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5ADC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7B87A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#697797"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear",
    x1: 47.643,
    y1: 67.7301,
    x2: 48.4097,
    y2: 67.7301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5ADC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7B87A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#697797"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear",
    x1: 11.5227,
    y1: 85.8033,
    x2: 47.6429,
    y2: 85.8033,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5ADC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7B87A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#697797"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear",
    x1: 46.8733,
    y1: 67.7286,
    x2: 47.6431,
    y2: 67.7286,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5ADC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7B87A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#697797"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear",
    x1: 46.3402,
    y1: 58.0902,
    x2: 46.8795,
    y2: 58.0902,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5ADC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7B87A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#697797"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear",
    x1: 46.3402,
    y1: 71.7495,
    x2: 46.8795,
    y2: 71.7495,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5ADC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7B87A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#697797"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear",
    x1: 46.3402,
    y1: 85.4085,
    x2: 46.8795,
    y2: 85.4085,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5ADC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7B87A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#697797"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear",
    x1: 12.2926,
    y1: 85.8025,
    x2: 46.8732,
    y2: 85.8025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A2ABC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8691AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear",
    x1: 10.0017,
    y1: 84.9835,
    x2: 46.5733,
    y2: 84.9835,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5ADC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7B87A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#697797"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear",
    x1: 19.0788,
    y1: 85.8048,
    x2: 40.0869,
    y2: 85.8048,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5ADC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7B87A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#697797"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear",
    x1: 185.368,
    y1: 101.104,
    x2: 240.557,
    y2: 101.104,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A2ABC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8691AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear",
    x1: 56.8407,
    y1: 93.8149,
    x2: 82.9933,
    y2: 93.8149,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A2ABC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8691AD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholderMachines);
export default __webpack_public_path__ + "static/media/placeholder_machines.1200268e32c954de7245d5f55c7572cd.svg";
export { ForwardRef as ReactComponent };